<template>
    <div class="wrap">
        <div class="head">
            <div class="logo">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/logo_1.png" class="logo_1">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/logo_2.png" class="logo_2">
            </div>
            <div class="kv">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/kv.png">
            </div>
        </div>
        <div class="content">
            <div class="icon"><!--图片区-->
                <div v-if="score<75">
                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_sad.png">
                </div>
                <div v-else-if="score==100">
                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_champion.png" style="width: 80px;height: 120px">
                </div>
                <div v-else>
                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_smile.png">
                </div>
            </div>
            <div class="score " :class="colorChoose(score)"><!--得分区-->
                <div class="number">
                    {{score}}
                </div>
                <div class="feng">
                    <div class="feng-wrap">
                        <label>分</label>
                    </div>
                </div>
            </div>
            <div class="text"><!--提示语区-->
                <label v-if="score<75">{{label_1}}</label>
                <label v-else>{{label_2}}</label>
            </div>
            <div ><!--按钮去-->
                <div v-if="score<75" class="btn">
                    <label class="label label_1" @click="reText">{{btn_1}}</label>
                </div>
                <div v-else-if="score!=100" class="btn">
                    <label class="label label_1" @click="questionShow=true">{{btn_2}}</label>
                    <label class="label label_2" @click="toStar">{{btn_3}}</label>
                </div>
                <div v-else class="btn">
                    <label  class="label label_2" @click="toStar">{{btn_3}}</label>
                </div>
            </div>
        </div>
        <div class="question" v-if="questionShow">
            <div class="close" @click="questionShow=false">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_close.png">
            </div>
            <div class="item" v-for="(question,index) in questions" v-bind:key="index">
                <div class="item-question">
                    <span>{{question.question}}</span>
                </div>
                <div class="item-resolve" v-for="(resolve,index) in question.resolves" v-bind:key="index" :class="resolve.isAnswer==1?'answer':''">
                        <span>{{resolve.resolve}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RepToken",
        data(){
            return{
                title:"得分",
                score:this.$route.params.score,
                label_1:"很遗憾，您未完成测试",
                label_2:"恭喜您，完成测试",
                btn_1:"重新测试",
                btn_2:"查看正确答案",
                btn_3:"进入达标之星",
                questionShow:false,
                questions: [
                    {
                        question:"1.STRONG研究中培哚普利/氨氯地平4mg/ 5mg治疗2周，血压降幅可达",
                        type:"1",
                        resolves:[{
                            resolve:"A、18/16mmHg",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"B、21/11mmHg",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"C、29/16mmHg",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"D、42/23mmHg",
                            check:0,
                            isAnswer:0
                        }]},
                    {
                        question:"2.AVANGARD研究显示，培哚普利/氨氯地平10/5mg（36.6%），治疗3个月，血压达标率可达",
                        type:"1",
                        resolves:[{
                            resolve:"A、85.6%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"B、90.2%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C、93.5%",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D、98.7%",
                            check:0,
                            isAnswer:0
                        }]},
                    {
                        question:"3.EMERALD研究显示，培哚普利/氨氯地平10/5mg（20.8%）治疗4个月，依从性高达",
                        type:"1",
                        resolves:[{
                            resolve:"A、98%",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B、90%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C、86%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"D、80%",
                            check:0,
                            isAnswer:0
                        }]
                    },
                    {
                        question:"4.ASCOT研究显示，氨氯地平5-10mg±培哚普利4-8mg可显著降低心血管死亡、卒中死亡和肾损伤风险分别为",
                        type:"1",
                        resolves:[{
                            resolve:"A、24%，29%，15%",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B、29%，25%，18%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C、20%，18，15%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"D、18%，22%，24%",
                            check:0,
                            isAnswer:0
                        }]
                    },
                ],
            }
        },
        methods:{
            colorChoose(score){
                if(score<75){
                    return "color-2"
                }else if(score==100){
                    return  "color-3"
                }else{
                    return "color-1"
                }
            },
            reText(){
                // this.$store.state.ksd_pdf = false//设置pdf未阅读完成
                this.$router.replace("docLearner")
            },
            toStar() {
                this.$router.replace("docStar")
            },
            toIndex(){
                this.$router.push({path:"./repIndex"})
            },
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
    }
    .content{
        flex-grow: 1;
    }
    .head{
        width: 100%;
        position: relative;
    }
    .head .logo{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;
        .logo_1{
            width: 30px;
            height: 30px;
            margin-left: 20px;
        }
        .logo_2{
            width: 90px;
            height: 30px;
            margin-right: 20px;
        }
    }
    .kv{
        width: 100%;
        height: 180px;
        display: flex;
        justify-content: center;
        img{
            width: 275px;
            height: 157px;
        }
    }
    .bottom{
        position: absolute;
        right: 0;
        bottom: -50px;
        img{
            width: 120px;
            height: 120px;
        }
    }
    .content{
        flex-grow: 1;
    }
    .content .icon{
        img{
            width: 80px;
            height: 80px;
        }
    }
    .content .score{
        display: flex;
        flex-direction: row;
        justify-content: center;
        /*margin-top: 10px;*/
        .number{
            font-size: 50px;
            font-weight: bold;
        }
        .feng{
            display: block;
            font-size: 20px;
            position: relative;
            .feng-wrap{
                position: absolute;
                bottom: 8px;
                left: 3px;
            }
        }
    }
    .content .text{
        font-size: 20px;
        margin-top: 10px;
    }
    .content .btn{
        display: flex;
        flex-direction: column;
        margin: 20px 0;
        .label{
            margin: 0 auto;
            width: 85%;
            border-radius: 5px;
            padding: 8px 0;
            font-size: 16px;
        }
        .label_1{
            border: #2c9a58 1px solid;
            color: #2c9a58;
        }
        .label_2{
            margin-top: 10px;
            background: #2c9a58;
            color: #FFF;
        }
    }

    .color-1{
        color: #2c9a58;
    }
    .color-2{
        color: #333;
    }
    .color-3{
        color: #1365a0;
    }

    .question{
        width: 90%;
        height: 80%;
        position: absolute;
        background: #FFF;
        left: 0;
        bottom: 0;
        top: 0;
        right: 0;
        margin: auto;
        overflow: scroll;
        border-radius: 15px;
    }

    .question .close{
            text-align: right;
            margin: 15px;
            img{
                width: 30px;
                height: 30px;
            }
    }
     .question .item{
        text-align: left;
         font-size: 16px;
    }
    .question .item .item-question{
        margin: 0 5px;
        background: #ddd;
        /*border-radius: 5px;*/

        padding: 3px 0 3px 5px ;
        /*padding-left: 5px;*/
        /*padding-top: 5px;*/
        /*padding-bottom: 5px;*/
    }
    .question .item .item-resolve{
        /*margin: 5px 0 5px 15px ;*/
        margin-top: 5px;
        margin-bottom: 5px;
        margin-left: 20px;
    }
    .answer{
        background: #2c9a58;
        margin-right: 15px;
        border-radius: 5px;
    }
</style>